import { render, staticRenderFns } from "./PrivacyPolicyEn.vue?vue&type=template&id=e8a32bbc&scoped=true"
var script = {}
import style0 from "./PrivacyPolicyEn.vue?vue&type=style&index=0&id=e8a32bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a32bbc",
  null
  
)

export default component.exports